import axios from 'axios';
import environment from 'environment';

import { JsonResponse, Pagination } from 'core/models/response';
import { Admin } from '../models/Admin';

interface GetAdminsResponse {
	admins: Admin[];
	pagination: Pagination;
}

export const onGetAdmins = (page = 1) => {
	return axios.get<JsonResponse<GetAdminsResponse>>(`${environment.BASE_API_ENDPOINT}/admin/admins`, {
		params: {
			page,
		},
	});
};

export const onGetAdmin = (adminId: string) => {
	return axios.get<JsonResponse<Admin>>(`${environment.BASE_API_ENDPOINT}/admin/admins/${adminId}`);
};

export const onCreateAdmin = (adminData: FormData) => {
	return axios.post<JsonResponse<GetAdminsResponse>>(`${environment.BASE_API_ENDPOINT}/admin/admins`, adminData, {
		headers: {
			'Content-Type': 'multipart/form-data',
		},
	});
};

export const onUpdateAdmin = (adminId: string, adminData: FormData) => {
	return axios.post<JsonResponse<Admin>>(`${environment.BASE_API_ENDPOINT}/admin/admins/${adminId}`, adminData, {
		headers: {
			'Content-Type': 'multipart/form-data',
		},
	});
};

export const onDeleteAdmin = (adminId: number) => {
	return axios.delete(`${environment.BASE_API_ENDPOINT}/admin/admins/${adminId}`);
};
